var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagicWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4814 4.78821C14.4049 4.71158 14.314 4.65078 14.214 4.60931C14.114 4.56783 14.0067 4.54648 13.8984 4.54648C13.7902 4.54648 13.6829 4.56783 13.5829 4.60931C13.4828 4.65078 13.392 4.71158 13.3154 4.78821L1.02625 17.0774C0.949583 17.154 0.888767 17.245 0.847274 17.3451C0.805781 17.4452 0.784424 17.5526 0.784424 17.661C0.784424 17.7693 0.805781 17.8767 0.847274 17.9768C0.888767 18.0769 0.949583 18.1679 1.02625 18.2445L3.35935 20.5776C3.43596 20.6543 3.52693 20.7151 3.62706 20.7566C3.72719 20.7981 3.83451 20.8194 3.9429 20.8194C4.05128 20.8194 4.15861 20.7981 4.25873 20.7566C4.35886 20.7151 4.44983 20.6543 4.52645 20.5776L16.8156 8.28841C16.8923 8.21189 16.9531 8.12101 16.9945 8.02097C17.036 7.92093 17.0574 7.8137 17.0574 7.70541C17.0574 7.59711 17.036 7.48988 16.9945 7.38984C16.9531 7.28981 16.8923 7.19893 16.8156 7.12241L14.4814 4.78821ZM13.8984 6.53831L15.0655 7.70541L3.94235 18.8275L2.77635 17.6615L13.8984 6.53831Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4813 9.45551L12.1482 7.12241C11.9927 6.97205 11.7843 6.8888 11.568 6.89058C11.3517 6.89235 11.1447 6.97902 10.9917 7.13191C10.8386 7.2848 10.7518 7.49168 10.7498 7.70799C10.7478 7.92431 10.8309 8.13274 10.9811 8.28841L13.3153 10.6226C13.4709 10.7728 13.6794 10.8559 13.8957 10.8539C14.112 10.8519 14.3189 10.7651 14.4718 10.612C14.6247 10.459 14.7113 10.252 14.7131 10.0357C14.7149 9.81939 14.6316 9.61104 14.4813 9.45551Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39951 6.8L9.14951 5.15L10.7995 4.4L9.14951 3.65L8.39951 2L7.64951 3.65L5.99951 4.4L7.64951 5.15L8.39951 6.8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 14.8L18.65 13.15L20.3 12.4L18.65 11.65L17.9 10L17.15 11.65L15.5 12.4L17.15 13.15L17.9 14.8Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6L18.9375 3.9375L21 3L18.9375 2.0625L18 0L17.0625 2.0625L15 3L17.0625 3.9375L18 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagicWand);
export default __webpack_public_path__ + "static/media/icon-magic-wand.79754cb480200d0151d86d1681771cc7.svg";
export { ForwardRef as ReactComponent };